import { render, staticRenderFns } from "./IngredientCost.vue?vue&type=template&id=39f4553b&scoped=true"
import script from "./IngredientCost.vue?vue&type=script&lang=ts"
export * from "./IngredientCost.vue?vue&type=script&lang=ts"
import style0 from "./IngredientCost.vue?vue&type=style&index=0&id=39f4553b&prod&scoped=true&lang=css"
import style1 from "./IngredientCost.vue?vue&type=style&index=1&id=39f4553b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4553b",
  null
  
)

export default component.exports